/**
 * P5-02: Loading screen bridge.
 *
 * The legacy module loader in index.html used to update #loadingProgressBar
 * and #loadingProgressInfo directly via jQuery. P5 moves the loading surface
 * into React, so index.html now reports progress through this bridge instead.
 *
 * Like toasts.ts, this uses a single-listener pattern because there is at most
 * one LoadingScreen mounted at a time.
 */

export type LoadingListener = (progress: number, message: string) => void;
export type LoadedListener = () => void;

let progressListener: LoadingListener | null = null;
let loadedListener: LoadedListener | null = null;
let pendingProgress: { progress: number; message: string } | null = null;
let pendingLoaded = false;

export function setLoadingProgressListener(l: LoadingListener | null): void {
  progressListener = l;
  if (l && pendingProgress) {
    const event = pendingProgress;
    pendingProgress = null;
    l(event.progress, event.message);
  }
}

export function setLoadingLoadedListener(l: LoadedListener | null): void {
  loadedListener = l;
  if (l && pendingLoaded) {
    pendingLoaded = false;
    l();
  }
}

export function setLoadingProgress(progress: number, message: string): void {
  if (progressListener) {
    progressListener(progress, message);
  } else {
    pendingProgress = { progress, message };
  }
}

export function setLoadingLoaded(): void {
  if (loadedListener) {
    loadedListener();
  } else {
    pendingLoaded = true;
  }
}
